//react
import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";
import { M, T } from "../../utils/MT";

//component
import MyPageProduct from "../content/MyPageProduct";
import BasicBtn from "../button/BasicBtn";
import StateBox from "../content/StateBox";
import modalScroll from "../../utils/ModalScroll";

// img
import product from "../../assets/img/picture/product_01.jpg";
import more from "../../assets/img/icon/icon_more2.svg";

// testData
import { OrderListData } from "../../Data";

export default function DeliveryModal(props) {
    // 배송 현황 리스트
    const deliveryListData = [
        {
            date: "2021.12.13",
            place: "군포 HUB",
            state: "배송중(입고)",
        },
        {
            date: "2021.12.13",
            place: "단원 SUB",
            state: "배송중(입고)",
        },
        {
            date: "2021.12.13",
            place: "단원 SUB",
            state: "배송중(입고)",
        },
        {
            date: "2021.12.13",
            place: "단원 SUB",
            state: "배송중(입고)",
        },
        {
            date: "2021.12.13",
            place: "군포 HUB",
            state: "배송중(입고)",
        },
        {
            date: "2021.12.13",
            place: "군포 HUB",
            state: "배송중(입고)",
        },
    ];

    return (
        <DeliveryWrap>
            <DelTitle>배송조회</DelTitle>

            {/* 주문상세내역 */}
            <StateWrap>
                <StateBox />
            </StateWrap>

            <OrderTableWrap>
                {/* 테이블 제목 */}
                <TabelTitle>
                    <TableList>
                        <PC>주문일자</PC> <span>{OrderListData[2].date}</span>
                    </TableList>
                    <TableList>
                        <PC>주문번호</PC> <span>{OrderListData[2].ordernum}</span>
                        <MoreBtn>
                            <img src={more} alt="아이콘" />
                        </MoreBtn>
                    </TableList>
                </TabelTitle>

                {/* 테이블 리스트 */}

                <OrderListBox>
                    <MyPageProduct
                        id={OrderListData[2].orderlist[0].id}
                        productImg={OrderListData[2].orderlist[0].productImg}
                        itemName={OrderListData[2].orderlist[0].itemName}
                        price={OrderListData[2].orderlist[0].price}
                        num={OrderListData[2].orderlist[0].num}
                        option={OrderListData[2].orderlist[0].option}
                        i={OrderListData[2].orderlist[0].id}
                    />
                    <DeliveryText>{OrderListData[2].orderlist[0].delivery !== "" ? OrderListData[2].orderlist[0].delivery : "무료배송"}</DeliveryText>
                </OrderListBox>
            </OrderTableWrap>

            {/* 배송사 텍스트 박스 */}
            {/* 송장번호 없을때 뜨지 않습니다! */}
            <DeliveryBoxWrap>
                <DeliveryBox>
                    <DeliveryList>배송사</DeliveryList>
                    <DeliveryList>CJ대한통운</DeliveryList>
                    <DeliveryList>638908188030</DeliveryList>
                </DeliveryBox>

                <DeliveryBox>
                    <DeliveryList>배송기사</DeliveryList>
                    <DeliveryList>김신도</DeliveryList>
                </DeliveryBox>
            </DeliveryBoxWrap>

            <DelStateWrap>
                <DelStateList>
                    <DelStateTitle>처리일시</DelStateTitle>
                    <DelStateTitle>현재 위치</DelStateTitle>
                    <DelStateTitle>배송상태</DelStateTitle>
                </DelStateList>

                <StateListWrap>
                    {deliveryListData?.length > 0 ? (
                        <>
                            {deliveryListData.map((item, index) => {
                                return (
                                    <StateInfoList key={"deliveryList" + index}>
                                        <DelStateText>{item.date}</DelStateText>
                                        <DelStateText>{item.place}</DelStateText>
                                        <DelStateText>{item.state}</DelStateText>
                                    </StateInfoList>
                                );
                            })}
                        </>
                    ) : (
                        // 송장번호 미등록상태일때 보이는 텍스트입니다!
                        <NotOrderText>
                            운송장 미등록 상태이거나
                            <MbBr /> 업체에서 상품을 준비중입니다.
                        </NotOrderText>
                    )}
                </StateListWrap>
            </DelStateWrap>
            <DelBtnWrap>
                <BasicBtn
                    onClick={() => {
                        props.setDeliveryModal(false);
                        modalScroll.modalClosed();
                    }}
                    text="닫기"
                    gray={true}
                    black={true}
                />
            </DelBtnWrap>
        </DeliveryWrap>
    );
}

const OrderTableWrap = styled.article`
    margin-bottom: calc(100vw * (30 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (30 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: 0;
    }
`;
const TabelTitle = styled.ul`
    display: flex;
    align-items: center;

    padding: calc(100vw * (20 / 1920)) 0;

    border-top: 1px solid #000;
    border-bottom: 1px solid #dddddd;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        justify-content: space-between;
        padding: ${M(16)} 0;
    }
`;
const TableList = styled.li`
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Noto-R";

    font-size: calc(100vw * (15 / 1920));

    &:nth-child(1) {
        margin-right: calc(100vw * (40 / 1920));
    }
    & span {
        font-family: "Noto-M";
        font-size: calc(100vw * (15 / 1920));
        margin-left: calc(100vw * (10 / 1920));
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        &:nth-child(1) {
            margin-right: calc(100vw * (40 / 1300));
        }
        & span {
            font-size: calc(100vw * (15 / 1300));
            margin-left: calc(100vw * (10 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};

        &:nth-child(1) {
            margin-right: 0;
            margin-left: 0;
        }

        &:nth-child(2) {
            margin-right: 0;
            /* margin-right: ${M(13)}; */
        }
        & span {
            font-size: ${M(14)};
            /* margin-left: 0; */
        }
    }
`;
const MoreBtn = styled.div`
    display: flex;
    align-items: center;
    width: calc(100vw * (5 / 1920));
    height: calc(100vw * (10 / 1920));
    margin-left: calc(100vw * (10 / 1920));

    & img {
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (5 / 1300));
        height: calc(100vw * (10 / 1300));
        margin-left: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(6)};
        height: ${M(10)};
        margin-left: ${M(10)};
    }
`;
const OrderListBox = styled.div`
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dddddd;

    padding: calc(100vw * (20 / 1920)) 0;

    & > div {
        text-align: center;
    }
    & > div:nth-child(1) {
        display: flex;
        align-items: center;

        width: calc(100vw * (408 / 1920));
    }
    & > div:nth-child(2) {
        display: flex;
        justify-content: center;
        align-items: center;

        width: calc(100vw * (203 / 1920));
    }
    & > div:nth-child(3) {
        width: calc(100vw * (212 / 1920));
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;

        & > div:nth-child(1) {
            width: calc(100vw * (408 / 1300));
        }
        & > div:nth-child(2) {
            width: calc(100vw * (203 / 1300));
        }
        & > div:nth-child(3) {
            width: calc(100vw * (212 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;
        padding: ${M(20)} 0;

        & > div:nth-child(1) {
            width: 100%;
        }
        & > div:nth-child(2) {
            width: ${M(203)};
        }
        & > div:nth-child(3) {
            width: ${M(212)};
        }
    }
`;

const DeliveryText = styled.p`
    font-size: calc(100vw * (14 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        margin-top: ${M(10)};
        padding-left: ${M(98)};
        font-size: ${M(14)};
    }
`;

// 배송 모달
const DeliveryWrap = styled.div`
    width: calc(100vw * (840 / 1920));
    padding: 40px;
    overflow-y: auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (840 / 1300));
        padding: 0;
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        padding: 0;
    }
`;
const DelTitle = styled.h2`
    margin-bottom: calc(100vw * (43 / 1920));

    text-align: center;
    font-size: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (43 / 1300));
        font-size: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(20)};
        font-size: ${M(20)};
    }
`;
const StateWrap = styled.article`
    margin-bottom: calc(100vw * (30 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (30 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: 0;
    }
`;
const DeliveryBoxWrap = styled.article`
    display: flex;
    justify-content: space-between;

    margin: calc(100vw * (20 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;
        margin: ${M(20)} 0;
    }
`;
const DeliveryBox = styled.ul`
    display: flex;

    width: calc(100vw * (400 / 1920));
    height: calc(100vw * (50 / 1920));
    padding: calc(100vw * (15 / 1920)) calc(100vw * (20 / 1920));

    background: #fafafa;

    &:last-child {
        margin-left: calc(100vw * (10 / 1920));
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (400 / 1300));
        height: calc(100vw * (50 / 1300));
        padding: calc(100vw * (15 / 1300)) calc(100vw * (20 / 1300));

        &:last-child {
            margin-left: calc(100vw * (10 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        height: ${M(50)};
        padding: ${M(15)} ${M(20)};

        &:last-child {
            margin-left: 0;
            margin-top: ${M(10)};
        }
    }
`;
const DeliveryList = styled.li`
    &:nth-child(1) {
        font-size: calc(100vw * (14 / 1920));
        color: #8c8c8c;
    }
    &:nth-child(2) {
        margin-left: calc(100vw * (28 / 1920));
        margin-right: calc(100vw * (15 / 1920));
        font-size: calc(100vw * (14 / 1920));
        color: #444444;
    }
    &:nth-child(3) {
        font-size: calc(100vw * (14 / 1920));
        color: var(--main-color);
        text-decoration-line: underline;
    }

    @media screen and (max-width: 1300px) {
        &:nth-child(1) {
            font-size: calc(100vw * (14 / 1300));
        }
        &:nth-child(2) {
            margin-left: calc(100vw * (28 / 1300));
            margin-right: calc(100vw * (15 / 1300));
            font-size: calc(100vw * (14 / 1300));
        }
        &:nth-child(3) {
            font-size: calc(100vw * (14 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:nth-child(1) {
            font-size: ${M(14)};
        }
        &:nth-child(2) {
            margin-left: ${M(28)};
            margin-right: ${M(15)};
            font-size: ${M(14)};
        }
        &:nth-child(3) {
            font-size: ${M(14)};
        }
    }
`;
const DelStateWrap = styled.article`
    border-top: 1px solid #000;
`;
const DelStateList = styled.ul`
    display: flex;
    padding: calc(100vw * (10 / 1920)) 0;

    border-bottom: 1px solid #aaaaaa;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (10 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(6)} 0;
    }
`;
const DelStateTitle = styled.li`
    flex-shrink: 0;
    width: 33.3333%;
    font-size: calc(100vw * (14 / 1920));
    text-align: center;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;
const StateInfoList = styled(DelStateList)`
    border-bottom: 1px solid #dddddd;
    padding: calc(100vw * (15 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (15 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(11)} 0;
    }
`;
const DelStateText = styled(DelStateTitle)`
    font-family: "Noto-R";
`;

const DelBtnWrap = styled.div`
    width: calc(100vw * (180 / 1920));
    margin: calc(100vw * (40 / 1920)) auto 0;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (180 / 1300));
        margin: calc(100vw * (40 / 1300)) auto 0;
    }

    @media screen and (max-width: 900px) {
        width: ${M(300)};
        margin: ${M(40)} auto 0;

        & p {
            color: #aaaaaa;
        }
    }
`;
const NotOrderText = styled.p`
    display: flex;
    align-items: center;
    justify-content: center;

    margin-top: calc(100vw * (40 / 1920));
    font-size: calc(100vw * (15 / 1920));
    text-align: center;

    color: #aaaaaa;

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (40 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(60)};
        font-size: ${M(15)};
    }
`;
const StateListWrap = styled.div`
    height: calc(100vw * (175 / 1920));
    overflow-y: auto;

    @media screen and (max-width: 1300px) {
        height: calc(100vw * (175 / 1300));
    }

    @media screen and (max-width: 900px) {
        height: ${M(175)};

        &::-webkit-scrollbar {
            display: none;
        }
    }
`;
const MbBr = styled.br`
    display: none;

    @media screen and (max-width: 900px) {
        display: block;
    }
`;
